export default __webpack_public_path__ + "static/media/haj8.b20e7710.JPG";